import { toast } from 'react-toastify';

export const apiError = (error: any) => {
  // fetch rejects with a TypeError on a network failure; the message differs by browser
  // ('Failed to fetch' in Chrome, 'NetworkError ...' in Firefox, 'Load failed' in Safari).
  if (error instanceof TypeError) {
    toast.error('An error occurred while fetching data.');
  } else if (Array.isArray((error as any)?.error?.detail)) {
    (error as any)?.error?.detail.forEach((el: any) =>
      toast.error(el.msg, { autoClose: false, hideProgressBar: true }),
    );
  } else {
    // A response with no JSON detail, e.g. a proxy's HTML 502 or 504.
    const detail = (error as any)?.error?.detail;
    toast.error(detail || `Request failed${error?.status ? ` (${error.status})` : ''}.`, {
      autoClose: false,
      hideProgressBar: true,
    });
  }
};
